<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <v-card class="elevation-6">
            <v-card-text>
                <v-toolbar flat color="white">
                <v-toolbar-title>Συγγράμματα</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn  :disabled="!$store.getters.homePageInformation.bookAllowedPeriod"
                                    v-on="on"
                                    small
                                    fab
                                    color="primary"
                                    @click="addNewBook">
                                <v-icon large color="white">add</v-icon>
                            </v-btn>
                        </template>
                        <span>Προσθήκη νέου Συγγράμματος</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn class="ml-1" v-on="on"
                                   :loading="$store.getters.publisherBooksXlsx.isLoading"
                                   @click="startPublisherBooksXlsx"
                                   small
                                   fab
                                   color="primary"><v-icon large color="white">get_app</v-icon></v-btn>
                        </template>
                        <span>Κατάλογος Καταγεγραμμένων Βιβλίων Εκδότη</span>
                    </v-tooltip>
                </v-toolbar>

                <v-divider></v-divider>

                <v-card-title>
                    <v-row>
                        <v-col lg="6" md="6"  sm="12">
                            <v-text-field
                                    v-model="search"
                                    append-icon="search"
                                    label="Αναζήτηση"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-col>
                        <v-col lg="3" md="3"  sm="6">
                            <v-btn-toggle
                                    v-model="active"
                                    tile
                                    light
                                    color="primary"
                                    group
                            >
                                <v-btn  value="true" >
                                    Ενεργό
                                </v-btn>

                                <v-btn  value="false" >
                                    Ανενεργό
                                </v-btn>
                            </v-btn-toggle>
                        </v-col>

                        <v-col class="pa-0" lg="3" md="3"  sm="4">
                            <v-row class="pa-2">
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                                class="mr-3 mt-3"
                                                outlined
                                                color="primary"
                                                @click="checkPricingFilter()"
                                                v-on="on">
                                            <v-icon color="primary">mdi-filter-outline</v-icon>
                                            <v-icon color="primary">mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <span>Φίλτρο Κοστολόγησης</span>
                                </v-tooltip>
                                <v-switch
                                        dense
                                        v-show="enablePricingFilter"
                                        v-model="pricedFilterSwitch"
                                        color="#dbb600"
                                        inset>
                                </v-switch>
                                <v-icon v-show="enablePricingFilter" large class="pa-0" :color="pricedFilterSwitch? '#dbb600' : 'grey'"> euro_symbol</v-icon>
                            </v-row>
                        </v-col>

                    </v-row>

                </v-card-title>
                <v-data-table :key="tableRerenderCounter"
                        no-data-text="Δεν υπάρχουν δεδομένα."
                        :headers="headers"
                        @update:items-per-page="itemsPerPage=$event"
                        :page.sync="page"
                        :options.sync="tableOptions"
                        @page-count="pageCount = $event"
                        :items="filterByActive">


                    <template v-slot:item="{ item }">
                        <!-- TODO emit from book edit next/prev edition-->
                        <tr :class="item.id == selectedBookId ? 'primary white--text' : ''" @click="selectLine(item)">
                            <td class="text-center" @click="getAction(item, true)">
                                <v-icon v-if="item.finalizedByPublisher" color="green"> verified</v-icon>
                                <v-icon v-else color="red">warning</v-icon>
                                <v-icon class="ml-1" :color="(item.hasSubmittedPricing || item.price) ? '#dbb600' : 'grey'"> euro_symbol</v-icon>
                            </td>
                            <td class="text-center" @click="getAction(item, true)">{{ item.id }}</td>
                            <td class="text-center text-truncate" style="max-width: 70ch" @click="getAction(item, true)">{{ item.title}}</td>
                            <td class="text-center text-truncate" style="max-width: 30ch" @click="getAction(item, true)">{{ item.authors}}</td>
                            <td class="text-center text-truncate" style="max-width: 10ch" @click="getAction(item, true)">{{ item.editionNumber}}</td>
                            <td class="text-center text-truncate" style="max-width: 10ch" @click="getAction(item, true)">{{ item.volumeNumber}}</td>
                            <td class="text-center">

                                <v-tooltip v-if="item.active" top>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon
                                                @click="activateOrDeactivateBook(item.id, false)"
                                                color="lightSeaGreen"

                                                v-on="on">
                                            mdi-clipboard-check
                                        </v-icon>
                                    </template>
                                    <span>Το Σύγγραμμα είναι ενεργό. Πιέστε για απενεργοποίηση</span>
                                </v-tooltip>
                                <v-tooltip v-if="!item.active" top>
                                    <template  v-slot:activator="{ on }">
                                        <v-icon
                                                @click="activateOrDeactivateBook(item.id, true)"
                                                color="orange"

                                                v-on="on">
                                            mdi-clipboard-alert
                                        </v-icon>
                                    </template>
                                    <span>Το Σύγγραμμα είναι ανενεργό. Πιέστε για ενεργοποίηση</span>
                                </v-tooltip>
                                <v-tooltip top>
                                    <template v-slot:activator="{ on }">
                                        <v-icon :disabled="$store.getters.homePageInformation.bookAllowedPeriod ? item.groupBooksSize > 0 ? true : false : true"
                                                @click="getAction(item, false)"
                                                color="red"
                                                class="mr-1 ml-1"
                                                v-on="on">
                                            delete
                                        </v-icon>
                                    </template>
                                    <span>Διαγραφή Συγγράμματος</span>
                                </v-tooltip>

                                <v-tooltip top>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon :disabled="item.archives != null ? item.archives.length == 0 ? true : false : true"
                                                @click="openHistoryModal(item)"
                                                color="info"
                                                v-on="on">history</v-icon>
                                    </template>
                                    <span>Ιστορικό Συγγράμματος</span>
                                </v-tooltip>
                            </td>
                        </tr>

                    </template>

                </v-data-table>
                <div class="text-center pt-2">
                    <v-pagination
                            v-model="page"
                            :length="pageCount"
                            total-visible="15"
                    ></v-pagination>
                </div>
            </v-card-text>

        </v-card>

        <v-dialog
                v-model="dialog"
                width="500">

            <v-card>
                <v-card-title
                        class="headline primary white--text"
                        primary-title>
                    Επιβεβαίωση
                </v-card-title>

                <v-card-text class="mt-5">
                    <p>Διαγραφή Βιβλίου;</p>
                    <p class="red--text">{{title}}</p>
                </v-card-text>

                <v-divider></v-divider>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            text
                            @click="dialog = false">
                        Ακύρωση
                    </v-btn>
                    <v-btn
                            color="primary"
                            text
                            @click="deleteBook">
                        Διαγραφή
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <BookHistory :bookHistory="bookHistory"/>

    </div>
</template>

<script>

    import {eventBus} from "../../main";
    import BookHistory from "./BookHistory";
    import service from '../../service'
    import request from "../../requests"
    import utils from "../../utilities"

    export default {
        name: "BooksTable",
        components: {BookHistory},
        data: () => ({
            utils,
            page: 1,
            pageCount: 0,
            pricedFilterSwitch: false,
            enablePricingFilter: false,
            itemsPerPage:10,
            tableOptions:{},
            preRedirectPage:1,
            title: '',
            active: undefined,
            id: '',
            dialog: false,
            selectedBookId: '',
            lastToggledBookId: null,
            search: '',
            tableRerenderCounter: 0,
            headers: [
                { text: 'Ολοκλ.Εγγραφή', align: 'center', value: 'finalizedByPublisher', width: '1%'},
                { text: 'Κωδικός', align: 'center', filterable: true, value: 'id', width: '7%'},
                { text: 'Τίτλος', value: 'title', align: 'center', width: '45%'},
                { text: 'Συγγραφείς', value: 'authors', align: 'center', width: '25%'},
                { text: 'Αρ. Έκδοσης', value: 'editionNumber', align: 'center', width: '1%'},
                { text: 'Τόμος', value: 'volumeNumber', align: 'center', width: '1%'},
                { text: 'Ενέργειες', value: 'fat', align: 'center', sortable: false , width: '17%'},

            ],
            bookHistory: [],
        }),

        methods: {

            checkPricingFilter(){
                if(this.enablePricingFilter===true){
                    this.pricedFilterSwitch = false;
                    this.enablePricingFilter= false;

                }else {
                    this.enablePricingFilter= true;
                }
            },

            activeInactiveEnabled() {
                if(this.search.trim().length >0){
                    return true;
                }else{
                    return false;
                }

            },


            selectLine(item){
                utils.setLocalStorage('redirectedBook', JSON.parse(JSON.stringify(item)));
                var preRedirectTable={};
                preRedirectTable.page = this.tableOptions.page;
                preRedirectTable.pageCount = this.pageCount;
                preRedirectTable.itemsPerPage = this.itemsPerPage;
                utils.setLocalStorage('preRedirectTable', preRedirectTable);
                this.preRedirectPage = this.tableOptions.page;
                this.selectedBookId = item.id;
            },

            startPublisherBooksXlsx(){
                service.startServicePublisherBooksXls();
            },

            openHistoryModal(item){
                this.bookHistory = item.archives;
                this.$store.commit('setBookHistoryModal', true);
            },

            getAction(item, deleteORedit) {

                this.$store.commit('setEditPublisherBook', item);
                if (deleteORedit) {
                    eventBus.$emit('createEditFields', true);
                    return
                }
                this.$store.commit('setEditPublisherBook', {});
                this.title = item.title;
                this.id = Number(item.id);
                this.dialog = true;
                eventBus.$emit('deleteItem');
            },

            // delete the current book
            deleteBook() {
                this.dialog = false;
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.deleteBook(token, this.id, this.deleteBookCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            deleteBookCallBack(response) {

                this.$store.commit('setPublisherBooks', response.bookList);
                this.$store.commit('setLoadingModal', false);
            },

            getRow(item) {

            },

            activateOrDeactivateBook (bookId, activate){
                var book = {};
                book.id = bookId;
                book.active = activate;
                this.lastToggledBookId = bookId;
                this.$store.commit('setLoadingModal', true);
                request.put('rest/books/activate-deactivate', book, this.activateOrDeactivateBookCallBack);
            },

            activateOrDeactivateBookCallBack(response){
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setPublisherBooks', response);
                // Αν το σύγγραμμα που άλλαξε κατάσταση είναι το ανοιχτό στο BookEdit,
                // ξαναφόρτωσέ το ώστε να ανανεωθούν οι ενδείξεις χωρίς νέο κλικ.
                var toggledId = this.lastToggledBookId;
                var openBook = this.$store.getters.editPublisherBook;
                if (openBook && openBook.id === toggledId) {
                    var updated = response.find(function(b){ return b.id === toggledId; });
                    if (updated) {
                        this.$store.commit('setEditPublisherBook', updated);
                        eventBus.$emit('createEditFields', true);
                    }
                }
                this.tableRerenderCounter++;
            },

            //add new book
            addNewBook() {
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    var bookObj = {
                        type: 'Published',
                        active: true
                    };
                    this.$store.commit('setLoadingModal', true);
                    request.addNewBook(token, bookObj, this.addNewBookCallBack)
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            addNewBookCallBack(response) {

                this.$store.commit('setEditPublisherBook', response);
                var books = this.$store.getters.publisherBooks;
                books.push(response);
                for(let i = 0; i < books.length; i++ ) {
                    for (let j = 0; j < books.length-1; j++) {
                        if (books[j+1].id>books[j].id) {
                            let tmp = books[j];
                            books[j]=books[j+1];
                            books[j+1]=tmp;
                        }
                    }
                }
                this.$store.commit('setPublisherBooks', books);
                eventBus.$emit('addNewBook');
                this.$store.commit('setLoadingModal', false);
            },

            //get all publisher books
            getAllPublisherBooks() {
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getAllPublisherBooks(token, this.getAllPublisherBooksCallBack);
                }
                else {
                    this.$store.commit('setloginModal', true);
                }
            },

            //call back publisher Books
            getAllPublisherBooksCallBack(response) {
                //console.log('books callback');
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setPublisherBooks', response);
                if( utils.getLocalStorage('redirectSent') ){
                    this.selectedBookId = utils.getLocalStorage('redirectedBook').id;
                    var preRedirectTable=utils.getLocalStorage('preRedirectTable');
                    this.page = preRedirectTable.page;
                    this.pageCount = preRedirectTable.pageCount;
                    this.itemsPerPage = preRedirectTable.itemsPerPage;
                    this.$store.commit('setEditPublisherBook', utils.getLocalStorage('redirectedBook'));
                    eventBus.$emit('createEditFields', true);
                    // console.log('after emit in bookstable')
                    // utils.deleteLocalStorage('redirectedBook');
                    // utils.deleteLocalStorage('preRedirectTable');
                     utils.deleteLocalStorage('redirectSent');
                    // console.log('after deletes in bookstable')
                }
            },

            //this is used as a part of search and filtering we use it along every other condition
            //if pricing filter is active add extra condition else true
            checkAlongWithSearchFilter(searchFilterBook, enablePricingFilter, pricedFilterSwitchValue){
                if( enablePricingFilter === true) {
                    if (searchFilterBook.hasSubmittedPricing != null) {
                        let pricedFlag = searchFilterBook.hasSubmittedPricing || searchFilterBook.price != null;

                        return pricedFlag === pricedFilterSwitchValue;

                    }
                }else{
                    return true; // so that the search can continue without the pricedFilterSwitchValue
                }
            },
        },
        computed: {
            filterByActive: function() {

                //check if active/inactive toggle buttons are pressed and filter books accordingly
                var booksFilteredByActive = this.$store.getters.publisherBooks.filter((bookObj) => {

                    if (this.active != 'undefined') {
                        return bookObj.active.toString().match(this.active);
                    } else {
                        return bookObj
                    }
                });
                var vm = this;
                // re-filter the remaining books(or all if the previous filter returns all) with search
                return booksFilteredByActive.filter((searchFilterBook) => {
                    if(vm.search.trim().length>0) {

                        // compare fields with the search text and with pricing filter
                        if (searchFilterBook.title !== '' && searchFilterBook.title != null) {
                            if (searchFilterBook.title.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
                                return searchFilterBook.title.toLowerCase().match(vm.search.toLowerCase()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.subtitle !== '' && searchFilterBook.subtitle != null) {
                            if (searchFilterBook.subtitle.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
                                return searchFilterBook.subtitle.toLowerCase().match(vm.search.toLowerCase()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.authors !== '' && searchFilterBook.authors != null) {
                            if (searchFilterBook.authors.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
                                return searchFilterBook.authors.toLowerCase().match(vm.search.toLowerCase())  && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.isbn !== '' && searchFilterBook.isbn != null) {
                            if (searchFilterBook.isbn.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
                                return searchFilterBook.isbn.toLowerCase().match(vm.search.toLowerCase()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.volumeTitle !== '' && searchFilterBook.volumeTitle != null) {
                            if (searchFilterBook.volumeTitle.toLowerCase().indexOf(vm.search.toLowerCase()) !== -1) {
                                return searchFilterBook.volumeTitle.toLowerCase().match(vm.search.toLowerCase()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.volumeNumber !== '' && searchFilterBook.volumeNumber != null) {
                            if (searchFilterBook.volumeNumber.indexOf(vm.search) !== -1) {
                                return searchFilterBook.volumeNumber.match(vm.search) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.editionNumber !== '' && searchFilterBook.editionNumber != null) {
                            if (searchFilterBook.editionNumber.indexOf(vm.search) !== -1) {
                                return searchFilterBook.editionNumber.match(vm.search) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.id !== '' && searchFilterBook.id != null) {
                            if (searchFilterBook.id.toString().indexOf(vm.search.toString()) !== -1) {
                                return searchFilterBook.id.toString().match(vm.search.toString()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if (searchFilterBook.publicationYear !== '' && searchFilterBook.publicationYear != null) {
                            if (searchFilterBook.publicationYear.toString().indexOf(vm.search.toString()) !== -1) {
                                return searchFilterBook.publicationYear.toString().match(vm.search.toString()) && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch);
                            }
                        }
                        if(('ολοκληρωμένη').indexOf(vm.search.toLowerCase()) !== -1 ){
                            if(searchFilterBook.finalizedByPublisher === true && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch)){
                                return searchFilterBook;
                            }
                        }
                        if(('εκκρεμής').indexOf(vm.search.toLowerCase()) !== -1 ){
                            if(searchFilterBook.finalizedByPublisher === false && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch)){
                                return searchFilterBook;
                            }
                        }
                        if(searchFilterBook.keywords.length>0 && searchFilterBook.keywords != null){
                            for(let i=0; i<searchFilterBook.keywords.length; i++){
                                if(searchFilterBook.keywords[i].toLowerCase().indexOf(vm.search.toLowerCase()) !== -1 && vm.checkAlongWithSearchFilter(searchFilterBook, vm.enablePricingFilter, vm.pricedFilterSwitch)){
                                    return searchFilterBook;
                                }
                            }

                        }

                    }else{
                        if( vm.enablePricingFilter === true){
                            if (searchFilterBook.hasSubmittedPricing != null) {
                                let pricedFlag = searchFilterBook.hasSubmittedPricing || searchFilterBook.price!=null;

                                return pricedFlag === vm.pricedFilterSwitch;

                            }
                        }else{
                            return searchFilterBook;
                        }

                    }
                });
            },
        },



        mounted() {
            this.getAllPublisherBooks();
            //console.log('books table mounted');
            eventBus.$on('specialEventName',(selectedBookId)=>{
                this.selectedBookId = id;
            });
        },

        created() {
            if(utils.getLocalStorage('preRedirectPage')){
                this.page = utils.getLocalStorage('preRedirectPage');
            }
        },

        beforeDestroy() {
            eventBus.$off('specialEventName');
        }
    }
</script>

<style scoped>

</style>